import { createSlice } from "@reduxjs/toolkit";
import axios from "../../utils/axios";

const backendUrl = process.env.REACT_APP_BACKEND_URL_V2;

const initialState = {
  isLoading: false,
  error: null,
  promotions: [],
  promotion: null,
  totalResults: 0,
};

const slice = createSlice({
  name: "promotions",
  initialState,

  reducers: {
    startLoading(state) {
      state.isLoading = true;
      state.error = null;
    },

    hasError(state, action) {
      state.isLoading = false;
      state.error = action.payload;
    },

    getPromotionsSuccess(state, action) {
      state.isLoading = false;

      state.promotions = action.payload?.results || [];

      state.totalResults =
        action.payload?.totalResults || state.promotions.length;
    },

    getPromotionSuccess(state, action) {
      state.isLoading = false;

      state.promotion = action.payload || null;
    },

    finishLoading(state) {
      state.isLoading = false;
    },
  },
});

export default slice.reducer;

export function getPromotions({ franchiseId, page = 1, limit = 1000 }) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());

    try {
      const response = await axios.get(`${backendUrl}/franchise/promotion`, {
        params: {
          franchiseId,
          page,
          limit,
        },
      });

      dispatch(slice.actions.getPromotionsSuccess(response.data));

      return response.data;
    } catch (error) {
      dispatch(slice.actions.hasError(error?.message));

      throw error;
    }
  };
}

export function getPromotion({ franchiseId, promotionId }) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());

    try {
      const response = await axios.get(
        `${backendUrl}/franchise/promotion/${promotionId}`,
        {
          params: {
            franchiseId,
          },
        },
      );

      dispatch(slice.actions.getPromotionSuccess(response.data));

      return response.data;
    } catch (error) {
      dispatch(slice.actions.hasError(error?.message));

      throw error;
    }
  };
}

export function deletePromotionById({ franchiseId, promotionId }) {
  return async (dispatch) => {
    await axios.delete(`${backendUrl}/franchise/promotion/${promotionId}`, {
      params: {
        franchiseId,
      },
    });

    return true;
  };
}
